export default {
  data(){
    return {
      screenWidth : 0,
    }
  },
  computed : {
    mobile(){
      return this.screenWidth < 800;
    },
    large(){
      return this.screenWidth >= 800;
    }
  },
  created(){
    window.addEventListener('resize', this.updateScreenWidth);
    this.updateScreenWidth();
  },
  unmounted(){
    window.removeEventListener('resize', this.updateScreenWidth);
  },
  methods : {
    updateScreenWidth(){
      this.screenWidth = window.innerWidth;
    }
  }
}
